module.exports = __webpack_public_path__ + "static/media/film-production-grid-5.918c8f57.jpg";